import { Checkbox, Empty, message, Modal, Spin } from "antd";
import React, { useState } from "react";
import FullScreenLoader from "../../../../Components/FullScreenLoader";
import { svg } from "../../../../../Assets/svg";
import { BtnLoader } from "../../../../../Components/Components";
import { RootState, useAppSelector } from "../../../../../store";

const PrintPreviewModal = ({
  visible,
  setIsModalVisible,
  loading,
  previewImage,
  dymo,
  cleanXml,
  setPreviewImage,
  activeKey
}: any) => {
    const {  getOrderProductionDepartment } =
      useAppSelector((state: RootState) => state.orders);
  const [printLoader, setPrintLoader] = useState(false);
console.log(previewImage,"previewImage")
  const onClose = () => {
    setPreviewImage([])
    setIsModalVisible(false);
  };
  const handlePrint = async (): Promise<void> => {
    const newData = previewImage?.filter((elem: any) => elem?.selected)
    if (newData?.length == 0) {
      message.error("Please select alleast one label for print")
      return
    }
    try {
      setPrintLoader(true);
      const printers = await dymo.getPrinters();
      if (!printers?.success || printers?.data?.length === 0) {
        message.error("No printer found");
        setIsModalVisible(true);
        return;
      }
      const myPrinter = printers?.data?.[0];

      if (myPrinter) {
        const sleep = (ms: any) => new Promise(resolve => setTimeout(resolve, ms));
        for (let i = 0; i < previewImage.length; i++) {
          const elem = previewImage[i];
          if (elem?.selected) {
            await dymo.printLabel(
              myPrinter?.model,
              elem?.XML,
              { copies: 1, jobTitle: `SM-CRM Job print ${elem?.id}` }
            );

            // wait 1 second before next print
            await sleep(300);
          }
        }
        onClose();
      }
      message.success(`Print job sent successfully to ${myPrinter.name}`);
      // if (myPrinter) {
      //   await dymo.print(myPrinter?.name, cleanXml);
      //   onClose();
      //   console.log("Print job sent successfully to:", myPrinter.name);
      // }
      // else {
      //   message.error("No printer found");
      //   setIsModalVisible(true);
      // }
    } catch (error: any) {
      alert(JSON.stringify(error));
      message.error(error?.message || "Not able to print");
      setIsModalVisible(true);
    } finally {
      setPrintLoader(false);
    }
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">Print Preview For {activeKey == "all" ? "All":getOrderProductionDepartment.find((elem:any)=>elem?._id == activeKey)?.name} Department</div>
      }
      visible={visible}
      onCancel={onClose}
      width={"60rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-primary min-w-130"
            onClick={handlePrint}
            disabled={printLoader}
          >
            {printLoader ? <BtnLoader /> : "PRINT"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div
      // style={{
      //   minHeight: "150px",
      //   display: "flex",
      //   justifyContent: "center",
      //   alignItems: "center",
      //   background: "#f5f5f5",
      //   borderRadius: "8px",
      //   padding: "20px",
      // }}
      >
        {loading ? (
          <FullScreenLoader />
        ) : previewImage?.length > 0 ? (
          <div className="row gy-3">
            {previewImage?.map((elem: any) => {
              return (
                <div className="col-sm-6 d-flex gap-2" key={elem?.id}>
                  <Checkbox
                    checked={elem?.selected}
                    onChange={(e) => {
                      const newData = previewImage?.map((prv: any) => (prv?.id == elem?.id ? { ...prv, selected: e?.target?.checked } : prv))

                      setPreviewImage((prev: any) => (
                        prev?.map((pre: any) => (
                          pre?.id === elem?.id
                            ? { ...pre, selected: e?.target?.checked }
                            : pre)
                        ))
                      );
                    }
                      // setPreviewImage((prev:any)=>prev?.map((pre:any)=>(prev?.id == elem?.id ? {...pre,selected:e?.target?.checked}:pre)))
                    }
                    className="fw-bold fs-6 mb-4 custom-checkbox"
                  >

                  </Checkbox>
                  <img
                    style={{ maxWidth: "calc(100% - 30px)" }}
                    src={elem?.preview}
                    alt="Label Preview"
                    className="shadow img-fluid"
                  />
                </div>
              )
            })}
          </div>
        ) : (
          <Empty description="No Preview Available" />
        )}
      </div>
    </Modal>
  );
};

export default PrintPreviewModal;
